function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export default class DMPConnectHttpInstance {
  constructor(accessToken) {
    _defineProperty(this, "url", "https://localhost.icanopee.net:9982");
    _defineProperty(this, "transactionsTimeoutInSeconds", 60);
    this.accessToken = accessToken;
  }
  async hl_findDocuments(nir, dmpConnectJSCriteria, callback) {
    return this._fetchDmpConnectJS("hl_findDocuments", Object.assign({
      s_ins: nir
    }, dmpConnectJSCriteria), callback);
  }
  async hl_updateUserDmpAccessAuthorization(nir, action, _isTreatingPhysician, _optionalParameters, callback) {
    return this._fetchDmpConnectJS("hl_updateUserDmpAccessAuthorization", {
      s_ins: nir,
      i_action: action,
      i_setTreatingPhysician: _isTreatingPhysician
    }, callback);
  }
  async hl_getDirectAuthenticationDMPStatus(nir, callback) {
    return this._fetchDmpConnectJS("hl_getDirectAuthenticationDMPStatus", {
      s_ins: nir
    }, callback);
  }
  async hl_createDmpConnector(dmpServerName, transactionsTimeoutInSeconds, practiceSetting, cpsPracticeLocationIndice, optionalParameters, callback) {
    let serverUrl = "";

    // Empty string => production DMP.
    if (dmpServerName === "") serverUrl = "https://lps2.dmp.gouv.fr/si-dmp-server/v2/services";else {
      if (dmpServerName.slice(0, 8) == "https://") {
        serverUrl = dmpServerName;
      } else {
        serverUrl = "https://" + dmpServerName + ".dmp.gouv.fr/si-dmp-server/v2/services";
      }
    }
    return this._fetchDmpConnectJS("hl_createDmpConnector", Object.assign({
      s_dmpUrl: serverUrl,
      i_transactionsTimeout: transactionsTimeoutInSeconds,
      s_practiceSetting: practiceSetting,
      i_cpsPracticeLocationIndice: cpsPracticeLocationIndice
    }, optionalParameters), callback);
  }
  async hl_setConfidentialityLevel(enableSecretConnection, callback) {
    return this._fetchDmpConnectJS("hl_setConfidentialityLevel", {
      i_enableSecretConnection: enableSecretConnection
    }, callback);
  }
  async hl_createInsiConnector(tlsiServeurFullUrl, transactionsTimeoutInSeconds, practiceSetting, cpsPracticeLocationIndice, _optionalParameters, callback) {
    return this._fetchDmpConnectJS("hl_createTlsiConnector", {
      s_tlsiUrl: tlsiServeurFullUrl,
      i_transactionsTimeout: transactionsTimeoutInSeconds,
      s_practiceSetting: practiceSetting,
      i_cpsPracticeLocationIndice: cpsPracticeLocationIndice
    }, callback);
  }
  async hl_sessionExists(_options, callback) {
    return this._fetchDmpConnectJS("hl_sessionExists", {
      s_sessionId: this.sessionId
    }, callback);
  }
  async hl_closeSession(callback) {
    if (!this.sessionId) {
      callback({
        error: new Error("There is no current session")
      });
    }
    return this._fetchDmpConnectJS("hl_closeSession", {
      s_sessionId: this.sessionId
    }, callback);
  }
  async hl_openSessionWithCustomDcParam(_cachedDcParameters, _timeoutInSeconds, cachedNetworkParams, callback) {
    return this.hl_openSession(cachedNetworkParams, cachedNetworkParams.configuration, callback);
  }
  async hl_openSession(cachedNetworkParams, configuration, callback) {
    const params = cachedNetworkParams ? cachedNetworkParams : {};
    return fetch(`${this.url}/api/hl_openSession`, {
      method: "POST",
      body: JSON.stringify(Object.assign({
        s_commandName: "hl_openSession",
        s_sessionId: this.sessionId,
        i_timeoutInSeconds: this.transactionsTimeoutInSeconds,
        s_dcparameters64: configuration
      }, params))
    }).then(async response => {
      const data = await response.json();
      this.sessionId = data.s_sessionId;
      callback(data);
    }).catch(error => {
      callback({
        error: error
      });
    });
  }
  async hl_getWebPsDmpUrls(nir, i_getPscUrls, callback) {
    return this._fetchDmpConnectJS("hl_getWebPsDmpUrls", {
      s_ins: nir,
      i_getPscUrls
    }, callback);
  }
  async hl_getDocumentContentByUniqueId(nir, uniqueId, uuid, parameters, callback) {
    return this._fetchDmpConnectJS("hl_getDocumentContentByUniqueId", Object.assign({
      s_ins: nir,
      s_documentUniqueId: uniqueId,
      s_documentUuid: uuid
    }, parameters), callback);
  }
  async hl_getInsFromIdentityInformation(lpsInfoICanopee, birthName, given, sex, birthDate, birthPlace, callback) {
    return this._fetchDmpConnectJS("hl_getInsFromIdentityInformation", {
      LpsInfos: lpsInfoICanopee,
      s_birthName: birthName,
      s_given: given,
      i_sex: sex,
      s_birthDate: birthDate,
      s_birthPlace: birthPlace
    }, callback);
  }
  async hl_getCpxCard(readerNumber, readerName, callback) {
    return this._fetchDmpConnectJS("hl_getCpxCard", {
      i_readerNumber: readerNumber,
      s_readerName: readerName
    }, callback);
  }
  async hl_readCpxCard(callback) {
    return this._fetchDmpConnectJS("hl_readCpxCard", {}, callback);
  }
  async hl_getVitaleCard(readerNumber, readerName, callback) {
    return this._fetchDmpConnectJS("hl_getVitaleCard", {
      i_readerNumber: readerNumber,
      s_readerName: readerName
    }, callback);
  }
  async hl_readVitaleCard(callback) {
    return this._fetchDmpConnectJS("hl_readVitaleCard", {}, callback);
  }
  async hl_getPcscReaders(callback) {
    return this._fetchDmpConnectJS("hl_getPcscReaders", {}, callback);
  }
  async sendHttpCommand(params, path, callback) {
    return this._fetchDmpConnectJS(path, params, callback, "remotecommand");
  }
  async getStellairToken() {
    return fetch("/api/v1/openid-token", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.accessToken}`
      }
    }).then(async res => {
      const resp = await res.json();
      return resp["token"];
    });
  }
  async _fetchDmpConnectJS(path, _body, callback, subPath = "api") {
    let token = null;
    if (this.sessionId) {
      token = await this.getStellairToken();
      await fetch(`${this.url}/${subPath}/hl_updateCpxAuthenticationToken`, {
        method: "POST",
        body: JSON.stringify({
          s_commandName: "hl_updateCpxAuthenticationToken",
          s_sessionId: this.sessionId,
          s_authenticationToken: token
        })
      });
    }
    return fetch(`${this.url}/${subPath}/${path}`, {
      method: "POST",
      body: JSON.stringify(Object.assign({
        s_authenticationToken: token,
        s_commandName: path,
        s_sessionId: this.sessionId
      }, _body))
    }).then(async response => {
      const json = await response.json();
      if (json.s_status == "ERROR") {
        callback({
          error: json
        });
        return;
      }
      callback(json);
    }).catch(error => {
      callback({
        error: error
      });
    });
  }
}